import React, { useCallback, useState } from "react";
import { Modal, Button, Skeleton, Spin, Card } from "antd";
import {  PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import AddUserModal from "./AddUserModal";
import { useTenantUsers } from "../../../hooks/useTenantUsers";
import { useDispatch } from "react-redux";
import { deleteAdvisor } from "../../../store/branch/thunks";
import Avatar from "../../../components/generic/Avatar";

const BranchesUserCards = (props) => {
  const { filteredBranches, loading, branchUsersLoading } = props;
  const [selectedBranch, setSelectedBranch] = useState(null);
  const { users, selectedTenantId } = useTenantUsers();
  const dispatch = useDispatch();

  const handleRemoveUser = useCallback(
    (branch, user) => {
      Modal.confirm({
        title: "Remove User",
        content: `Are you sure you want to remove ${
          user?.first_name + user?.last_name
        } from ${branch?.name} branch?`,
        okText: "Yes, Remove",
        okType: "danger",
        onOk: () => {
          return new Promise(async (resolve, reject) => {
            try {
              const result = await dispatch(
                deleteAdvisor({
                  user_ids: [user?.user_id],
                  branch_id: branch?.id,
                  tenant_id: selectedTenantId,
                })
              ).unwrap();

              resolve(result);
            } catch (error) {
              console.error(
                "🚀 ~ BranchesUserCards.jsx ~ handleRemoveUser ~ error:",
                error
              );
              reject(error);
            }
          });
        },
        onCancel: () => {
          console.log("User removal cancelled");
        },
      });
    },
    [dispatch, selectedTenantId]
  );

  return (
    <div>
      <div className="branch-grid">
        {loading ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : (
          filteredBranches.map((branch) => {
            const { id, name, users = [] } = branch;
            return (
              <Card className="branch-card" key={id}>
                <div className="branch-header">
                  <div className="flex">
                    <div className="branch-name">{name}</div>
                  </div>
                  <div className="user-count">
                    {users.length} {users.length === 1 ? "User" : "Users"}
                  </div>
                </div>

                <div className="user-list">
                  {branchUsersLoading ? (
                    <Spin
                      tip="Loading"
                      className="flex-center h-100"
                      size="large"
                    />
                  ) : users.length > 0 ? (
                    users.map((user) => (
                      <div className="user-item" key={user.id}>
                        <div className="user-info">
                          <Avatar size={36} user={user} />
                          <div className="user-details">
                            <div className="user-name">
                              {user.first_name} {user.last_name}
                            </div>
                            <div className="user-email">{user.email}</div>
                          </div>
                        </div>
                        <Button
                          type="text"
                          danger
                          size="small"
                          icon={<DeleteOutlined />}
                          onClick={() => handleRemoveUser(branch, user)}
                        />
                      </div>
                    ))
                  ) : (
                    <div className="empty-state">
                      <div className="empty-icon">👥</div>
                      <div className="empty-text">No users assigned</div>
                    </div>
                  )}
                </div>

                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setSelectedBranch(branch)}
                  block
                  disabled={branchUsersLoading}
                >
                  Add Users
                </Button>
              </Card>
            );
          })
        )}
      </div>
      {selectedBranch && (
        <AddUserModal
          selectedBranch={selectedBranch}
          handleCancel={() => setSelectedBranch()}
          users={users}
          selectedTenantId={selectedTenantId}
        />
      )}
    </div>
  );
};

export default BranchesUserCards;
